import * as React from 'react';
import EmbeddedPowerBIReport from 'components/Reporting';
import { ReportingTabProps } from 'types/reporting.type';

const InForceReport: React.FunctionComponent<ReportingTabProps> = (props) => {
    const { reportName } = props;
    const IN_FORCE_REPORT_IDS = 'ef908d9c-8722-4308-a99b-ff382edd42b0';
    const IN_FORCE_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';

    return (
        <>
            <EmbeddedPowerBIReport
                reportId={IN_FORCE_REPORT_IDS}
                workspaceId={IN_FORCE_WORKSPACE_ID}
                reportName={reportName}
                hideFilters
                waitForPrimary
            />
        </>
    );
};

export default InForceReport;
